export class CompetionMake {
    CompetitionMakeID : number;
    CompetitionMakeName : string;
    CompetitionMakeDescription : string;
    IsActive : boolean = true;
    ModifiedBy : number;
    
}